/**
 * @file 路由刷新版本 Store
 * @description 为 noCache 路由维护版本号，触发页面组件按路径刷新。
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * 路由刷新版本 Store。
 * @returns 路径版本表和版本更新/读取方法。
 */
export const useRouteRefreshStore = defineStore('route-refresh', () => {
  /** 路径到版本号的映射 */
  const versions = ref<Record<string, number>>({})

  /**
   * 更新指定路径的版本号。
   * @param path 路由路径。
   */
  function touch(path: string): void {
    versions.value[path] = Date.now()
  }

  /**
   * 获取指定路径的版本号。
   * @param path 路由路径。
   * @returns 当前路径版本号。
   */
  function getVersion(path: string): number {
    return versions.value[path] || 0
  }

  return { versions, touch, getVersion }
})
